import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';

const usePreviousPageData = ({ isListedPrice }: { isListedPrice: boolean }) => {
  const router = useRouter();
  const [isGridView, setIsGridView] = useState(true);

  const savePreviousData = useCallback(
    (url: string) => {
      const scrollPos = window.scrollY;
      sessionStorage.setItem(
        `scrollPos:${url}`,
        JSON.stringify({
          scrollPos,
          isGrid: isGridView,
          isListed: isListedPrice,
        })
      );
    },
    [isGridView, isListedPrice]
  );

  const restorePreviousData = (url: string) => {
    const restoreData = sessionStorage.getItem(`scrollPos:${url}`) || '{}';
    const { scrollPos, isGrid } = JSON.parse(restoreData);
    setIsGridView(isGrid);
    if (scrollPos !== null) {
      setTimeout(() => {
        window.scrollTo(0, Number(scrollPos));
      }, 100);
      sessionStorage.removeItem(`scrollPos:${url}`);
    }
  };

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';

      const handleRouteChangeStart = () => {
        savePreviousData(router.asPath);
      };

      const handleRouteChangeComplete = (url: string) => {
        const isBackNavigation = sessionStorage.getItem('isBackNavigation');
        if (isBackNavigation) {
          restorePreviousData(url);
        } else {
          sessionStorage.removeItem(`scrollPos:${url}`);
        }
        sessionStorage.removeItem('isBackNavigation');
      };

      router.beforePopState(() => {
        sessionStorage.setItem('isBackNavigation', 'true');
        return true;
      });

      router.events.on('routeChangeStart', handleRouteChangeStart);
      router.events.on('routeChangeComplete', handleRouteChangeComplete);

      return () => {
        router.events.off('routeChangeStart', handleRouteChangeStart);
        router.events.off('routeChangeComplete', handleRouteChangeComplete);
      };
    }
    return () => {};
  }, [router, savePreviousData]);

  return {
    isGridView,
    setIsGridView,
  };
};

export default usePreviousPageData;
